// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__FhwvF","header":"HomePage_header__ndTGw","board":"HomePage_board__Km7LM","link":"HomePage_link__29SvY","card":"HomePage_card__CaYMV"};